// extracted by mini-css-extract-plugin
export default {"main":"MainLayout_main__Pyiam","mainMobile":"MainLayout_mainMobile__NI+qx","container":"MainLayout_container__KQLMf"};